import { S25WsMicroOrganization } from "./MicroServices/S25WsMicroOrganization";
import { S25WsMicroResource } from "./MicroServices/S25WsMicroResource";
import { DataAccess } from "../dataaccess/data.access";
import { MicroUtil } from "./MicroServices/micro.util";
import { S25Util } from "../util/s25-util";
import { Timeout } from "../decorators/timeout.decorator";

export class ResourceMicroService {
    public static saveResource(
        resourceIds: number[],
        payload: Partial<S25WsMicroResource.Item>,
        include?: S25WsMicroResource.IncludeOptions[],
    ) {
        let url = "/micro/resource/list.json";
        url += include?.length ? `?expand=T&include=${include.join("+")}` : "";

        return DataAccess.put<S25WsMicroResource.ContentWrapper>(
            DataAccess.injectCaller(url, "ResourceMicroService.saveResource"),
            MicroUtil.wrapPayloadItem(payload),
        );
    }

    @Timeout
    public static async alterStock(
        resourceIds: number[],
        stock: S25WsMicroResource.Stock[],
        removedVersions: number[],
    ) {
        const item: Partial<S25WsMicroResource.Item> = {
            idList: resourceIds,
            stock: stock?.map(({ versionNbr, startDt, endDt, stockLevel }) => ({
                versionNbr,
                startDt,
                endDt,
                stockLevel,
            })),
            remove: { stock: removedVersions?.map((versionNbr) => ({ versionNbr })) },
        };

        const [resp, error] = await S25Util.Maybe(
            ResourceMicroService.saveResource(resourceIds, S25Util.deleteUndefDeep(item), ["stock"]),
        );
        if (error) {
            return Promise.reject(error.content?.error?.message || "Error occurred while saving resource");
        }
        return resp?.content;
    }
}
